import { defineMessagesSimple } from '@atlassiansox/bxpkit-core';

const ID_PREFIX = 'WacSignupForm.SimpleSignup';
export const messages = defineMessagesSimple(ID_PREFIX, {
  noCreditCardRequiredFooter: `Always free, no credit card needed.`,
  simpleSignupEula: `By clicking "Sign up", you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.`,
  simpleSignupRecaptcha:
    'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
  simpleSignupLoggedOutFormHeader: "Let's get started",
  simpleSignupLoggedOutFormSubHeader:
    'Your Free cloud plan supports up to 10 users and 2 GB of file storage.',
  siteNameFormHeader: 'Name your site',
  siteNameFormSubHeader:
    'Your site name will be in the URL to access your site, so pick a name that your team will recognize.',
  inputLabelWorkEmail: 'Work email',
  inputPlaceholderWorkEmail: 'Eg: you@company.com',
  inputLabelWorkEmailError: 'Invalid email address',
  inputLabelRequired: 'Enter your email',
  submitButtonLabel: 'Sign up',
  socialSignUpButtonSignupWithGoogle: 'Sign up with Google',
  socialSignUpButtonSignupWithMicrosoft: 'Sign up with Microsoft',
  socialSignUpButtonSignupWithApple: 'Sign up with Apple',
  socialSignUpButtonSignupWithSlack: 'Sign up with Slack',
  socialSignUpButtonSignUpWithEmail: 'Sign up with email',
  socialSignUpDividerLabel: 'OR',
  simpleSignupLoggedOutFormSubmitError:
    'Something went wrong, please try again.',
  simpleSignupSamlRequired:
    'You must use single sign-on to access your account and continue signing up for your product. <a href="{loginUrl}">Login to continue</a>',
  simpleSignupSsoCheckError:
    'There was an unexpected error validating your email. Please check your network settings.',
  marketingConsent: `Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.`,
  errorEmailInvalid: 'Please enter a valid email address',
  errorEmailInUse: `Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.`,
  errorSsoInUse: `You must use single sign-on to access your account and continue signing up for your product. <a href='{signInAccountUrl}'>Login to continue.</a>`,
  errorSitenameInvalid:
    'Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.',
  errorSitenameUnavailable: 'This suite is already taken.',
  inputLabelSitenameExisting:
    'Select a site (or type a name to create a new one)',
  inputToggleSitenameNew: 'Start a new site',
  inputToggleSitenameExisting: 'Use an existing site',
  inputLabelSitenameNew: 'Site name',
  inputDescriptionSitenameNew: `<p>By clicking "Finish", you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy.</a></p>`,
  provisioningTakesTime:
    'Please wait a moment, this can take up to a minute...',
  errorTimeoutN2E:
    '<span>It\'s taking longer than expected to get you started. Please <a href="/company/contact" track-link-ga="error-contact-us">contact us</a>.</span>',
  errorTimeoutN2N:
    '<span>It\'s taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <a href="/company/contact">contact us</a>.</span>',
  productListJiraSoftwareName: 'Jira Software',
  productListJiraSoftwareDescription: 'Mission control for your entire team',
  navProductName: 'Jira Software',
  navSubHeader: 'The #1 software development tool used by agile teams'
});
